import * as React from 'react';
import { Grid } from '@mui/material';
import FileUploaderItem from '../file-uploader-item';

export interface IManifestFileUploaderProps {
  Items: Array<IFileUpload>;
  SetFileForUpload: (category: string, file: File | null) => void;
  DeleteFile: (category: string) => void;
}

export default function ManifestFileUploader (props: IManifestFileUploaderProps) {
  return (
    <Grid container sx={{ width: '100%', }}>
      {props.Items && props.Items.map((item, index) => (
        <Grid item key={index} xs={4} sx={{ pr: 2, pb: 2 }}>
          <FileUploaderItem 
            File={item} 
            SetFileForUpload={props.SetFileForUpload} 
            DeleteFile={props.DeleteFile}
            Height={160} />
        </Grid>
      ))}
    </Grid>
  );
}